import { z } from 'zod';

// Login form schema
export const loginSchema = z.object({
  phone: z
    .string()
    .min(1, 'validation:required')
    .refine(
      (val) => {
        // Remove formatting characters and check length (9-12 digits)
        const digits = val.replace(/[+()\s]/g, '');
        return /^[0-9]{9,12}$/.test(digits);
      },
      { message: 'validation:phone' }
    ),
  password: z
    .string()
    .min(1, 'validation:required')
    .min(8, 'validation:password.minLength'),
});

export type LoginFormData = z.infer<typeof loginSchema>;
